/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCloudLightning(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M17.3 6.227C15.452.65 8.368-1.604 3.638 2.06a8.75 8.75 0 001.12 14.573.75.75 0 00.727-1.312 7.25 7.25 0 01-.929-12.075C8.59.12 14.738 2.223 16.015 7.165a.75.75 0 00.725.562H18a4.252 4.252 0 013.427 6.77 4.25 4.25 0 01-2.576 1.645.75.75 0 00.299 1.47A5.75 5.75 0 0018 6.227m-4.584 4.126a.75.75 0 01.208 1.04l-3.222 4.834H15a.75.75 0 01.624 1.166l-4 6a.75.75 0 01-1.248-.832l3.223-4.834H9a.75.75 0 01-.624-1.166l4-6a.75.75 0 011.04-.208z'
        />
      </g>
      <defs>
        <clipPath id='cloud-lightning_svg__clip0_126_10436'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgCloudLightning;
